export namespace RideStatusConstants {
  export const SCHEDULED = 'Scheduled';
  export const SELECT_DRIVER = 'Select Driver';
  export const DRIVER_EN_ROUTE = 'Driver en route';
  export const PICK_UP_ARRIVED = 'Pick-up arrived';
  export const IN_PROGRESS = 'In progress';
  export const DROP_OFF_ARRIVED = 'Drop-off arrived';
  export const COMPLETED = 'Completed';
  export const CANCELLED = 'Cancelled';
  export const PENDING = 'Pending';
}

export enum RideStatusOrder {
  'Scheduled' = 1,
  'Driver en route' = 2,
  'Pick-up arrived' = 3,
  'In progress' = 4,
  'Drop-off arrived' = 5,
  'Completed' = 6
}
